import * as React from 'react'
import LazyLoad from 'react-lazyload'
import { people, logos, products, office } from './images'

import styles from './images.module.scss'

interface IImagesProps {
  type: 'people' | 'logos' | 'products' | 'office'
}

export default function Images({ type }: IImagesProps) {
  const enums = {
    people,
    logos,
    products,
    office,
  }

  const imageBaseURL = 'https://drive.google.com/uc?export=view&id='
  const thumbnailURL = 'https://drive.google.com/thumbnail?id='

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <div className={styles.imageSections}>
            {enums[type].map((image) => (
              <a
                className={styles.imageSection}
                href={`${imageBaseURL}${image.imageId}`}
                key={image.imageId}
                rel="noopener noreferrer"
                target="_blank"
              >
                <LazyLoad once>
                  <img alt={image.alt} src={`${thumbnailURL}${image.imageId}`} title={image.alt} />
                  <h5>{image.heading}</h5>
                </LazyLoad>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
